import {
    ChangeDetectionStrategy,
    Component,
    inject,
    input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TelXLButtonComponent } from '@dxp/elements';
import { OverlayRef, TelXLOverlayComponent } from '@dxp/components';
import { IAttachmentFile } from '../attachments.component';
import { TelXLSingleAttachmentsComponent } from '../single-attachment/single-attachment.component';

@Component({
    selector: 'telxl-shared-multiple-attachments',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        TelXLOverlayComponent,
        TelXLButtonComponent,
        TelXLSingleAttachmentsComponent,
    ],
    templateUrl: './multiple-attachments.component.html',
    styleUrl: './multiple-attachments.component.scss',
})
export class TelXLMultipleAttachmentsComponent {
    readonly #overlayRef = inject(OverlayRef<undefined>);

    files = input.required<IAttachmentFile[]>();

    close() {
        this.#overlayRef.close(undefined);
    }
}
